import { render } from "./NotificationsTab.vue?vue&type=template&id=79d469b9&scoped=true"
import script from "./NotificationsTab.vue?vue&type=script&lang=js"
export * from "./NotificationsTab.vue?vue&type=script&lang=js"

import "./NotificationsTab.vue?vue&type=style&index=0&id=79d469b9&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d469b9"]])

export default __exports__